import React from "react";
import { Input, Label } from "@/components/ui";
import { Calendar } from "lucide-react";

/**
 * Date Range Filter Component
 *
 * Provides from/to date pickers for filtering by date range.
 * Requirements: 2.1-2.5, 5.1-5.9
 */
const DateRangeFilter = ({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
}) => {
  return (
    <div className="space-y-2">
      <Label className="flex items-center gap-2">
        <Calendar className="h-4 w-4" />
        Date Range
      </Label>
      <div className="grid grid-cols-2 gap-2">
        <div>
          <Label htmlFor="date-from" className="text-xs text-gray-600">
            From
          </Label>
          <Input
            id="date-from"
            type="date"
            value={dateFrom || ""}
            onChange={(e) => onDateFromChange(e.target.value)}
            className="w-full"
          />
        </div>
        <div>
          <Label htmlFor="date-to" className="text-xs text-gray-600">
            To
          </Label>
          <Input
            id="date-to"
            type="date"
            value={dateTo || ""}
            onChange={(e) => onDateToChange(e.target.value)}
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default DateRangeFilter;
